import * as React from "react";

interface IProps {
  color: string;
  outlineColor: string;
}

const GcpIcon: React.FC<IProps> = ({ color, outlineColor }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.8"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.02593 2.29184C7.82648 2.10227 7.57716 2.00249 7.31788 2.00249C7.06856 2.00249 6.80928 2.10227 6.6198 2.29184L2.2917 6.6221C1.90277 7.01122 1.90277 7.63981 2.2917 8.02893L6.26078 12L2.2917 15.9711L1.23077 14.9107L4.13999 12L1.23077 9.08933C0.256409 8.11448 0.256409 6.53655 1.23077 5.5617L5.55887 1.23145C6.03995 0.750131 6.68538 0.502494 7.31788 0.502494C7.97474 0.502494 8.59059 0.759079 9.05932 1.2046L9.07326 1.21785L11.995 4.14106L14.9032 1.23145C15.878 0.256184 17.4564 0.256184 18.4312 1.23145L22.7593 5.5617C23.7336 6.53655 23.7336 8.11448 22.7593 9.08933L19.8514 11.9987L22.7692 14.9107C23.7436 15.8855 23.7436 17.4634 22.7692 18.4383L18.4275 22.7822L18.4136 22.7954C17.9449 23.2409 17.329 23.4975 16.6722 23.4975C16.0496 23.4975 15.4076 23.2732 14.9032 22.7686L11.995 19.8589L9.08685 22.7686C8.11208 23.7438 6.53365 23.7438 5.55887 22.7686L1.23077 18.4383L2.2917 17.3779L6.6198 21.7082C7.00873 22.0973 7.637 22.0973 8.02593 21.7082L11.995 17.7371L15.9641 21.7082C16.1636 21.9077 16.4129 21.9975 16.6722 21.9975C16.9314 21.9975 17.1808 21.8977 17.3802 21.7082L21.7083 17.3779C22.0972 16.9888 22.0972 16.3602 21.7083 15.9711L17.7296 12.0003L21.6983 8.02893C22.0873 7.63981 22.0873 7.01122 21.6983 6.6221L17.3702 2.29184C16.9813 1.90272 16.353 1.90272 15.9641 2.29184L11.995 6.26291L8.02593 2.29184ZM2.2917 17.3779C1.90277 16.9888 1.90277 16.3602 2.2917 15.9711L1.23077 14.9107C0.25641 15.8855 0.25641 17.4634 1.23077 18.4383L2.2917 17.3779Z"
        fill={outlineColor}
      />
      <path
        d="M21.6983 8.02893L17.7292 12L21.7083 15.9711C22.0972 16.3602 22.0972 16.9888 21.7083 17.3779L17.3802 21.7082C17.1808 21.8977 16.9314 21.9975 16.6722 21.9975C16.4129 21.9975 16.1636 21.9077 15.9641 21.7082L11.995 17.7371L8.02593 21.7082C7.637 22.0973 7.00873 22.0973 6.6198 21.7082L2.2917 17.3779C1.90277 16.9888 1.90277 16.3602 2.2917 15.9711L6.26078 12L2.2917 8.02893C1.90277 7.63981 1.90277 7.01122 2.2917 6.6221L6.6198 2.29184C6.80928 2.10227 7.06856 2.00249 7.31788 2.00249C7.57716 2.00249 7.82648 2.10227 8.02593 2.29184L11.995 6.26291L15.9641 2.29184C16.353 1.90272 16.9813 1.90272 17.3702 2.29184L21.6983 6.6221C22.0873 7.01122 22.0873 7.63981 21.6983 8.02893Z"
        fill={color}
      />
    </svg>
  );
};

export default React.memo(GcpIcon);
